import { IGigPayoutsUpload } from "store/wh-partner-services/whPartnerServicesSlice";

const PERSIST_KEY = "wh_partner_earning_payouts_processing";

export const persistWhProcessingEarningPayouts = (data: IGigPayoutsUpload) => {
  try {
    localStorage.setItem(PERSIST_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error persisting WH Earning Payouts data:", error);
  }
};

export const getPersistedWhProcessingEarningPayouts = (): IGigPayoutsUpload => {
  try {
    const data = localStorage.getItem(PERSIST_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error retrieving WH Earning Payouts data:", error);
    return {};
  }
};

export const removePersistedWhProcessingEarningPayouts = () => {
  try {
    localStorage.removeItem(PERSIST_KEY);
  } catch (error) {
    console.error("Error removing WH Earning Payouts data:", error);
  }
};
